import React from "react";
import "./card.sass";
import {ReactComponent as Plus} from "../../svg/Plus.svg";
import {Draggable} from "react-beautiful-dnd";

function getStyle(style, snapshot) {
    if (!snapshot.isDropAnimating) {
        return {
            ...style,
            backgroundColor: snapshot.isDragging ? 'transparent' : 'white',
        };
    }
    return {
        ...style,
        backgroundColor: 'transparent',
        // cannot be 0, but make it super tiny
        transitionDuration: `0.001s`,
    };
}

const Card = (item) => {
    return (
        <Draggable
            key={item.itemKey}
            draggableId={item.itemId}
            index={item.itemKey}>
            {(provided, snapshot) => {
                return <>
                    <div className={`Card ${item.hidden ? "Card-hidden" : ""}`}
                         ref={provided.innerRef}
                         {...provided.draggableProps}
                         {...provided.dragHandleProps}
                        style={getStyle(provided.draggableProps.style, snapshot)}
                    >
                        <img src={item.images.card} loading="lazy" alt={item.title}/>
                        <Plus className="Card-plus"/>
                        <div className={`product-card-price dragging-visible ${snapshot.isDragging ? "Card-dragging" : ""}`}>{item.price}</div>
                        <div className={`Card-info ${snapshot.isDragging ? "Card-info-dragging" : ""}`}>
                            <span className="product-card-title">{item.title}</span>
                            <div className="product-card-price">{item.price}</div>
                        </div>
                    </div>
                    {snapshot.isDragging && (<div className="Card Card-cloned Card-dragging">
                            <div className="product-card-price dragging-visible ">{item.price}</div>
                            <img src={item.images.card} loading="lazy" alt={item.title}/>
                        </div>
                    )}
                </>
            }}
        </Draggable>
)
}

export default Card
